// extracted by mini-css-extract-plugin
export var cartContainer = "_jr-4";
export var gray = "_jr-1";
export var itemContainer = "_jr-2";
export var itemDetails = "_jr-3";
export var strong = "_jr-0";